import React from 'react';
import { Card } from './Card';

export const StatCard: React.FC<{ label: string; value: string; icon: any; trend?: string; color?: string }> = ({ label, value, icon: Icon, trend }) => (
  <Card className="p-6">
    <div className="flex items-center">
      <div className="p-3 rounded-full bg-indigo-100 text-indigo-600 mr-4">
        <Icon className="w-6 h-6" />
      </div>
      <div>
        <p className="text-sm font-medium text-gray-500">{label}</p>
        <p className="text-2xl font-semibold text-gray-900">{value}</p>
        {trend && <p className="text-xs text-green-600 mt-1">{trend}</p>}
      </div>
    </div>
  </Card>
);